// utils/textUtils.js
// utils/textUtils.js
function preserveFirstCase(src, repl) {
    // dacă primul char din sursă e uppercase, facem și înlocuirea cu majusculă
    if (src && src[0] === src[0].toUpperCase()) {
        return repl.charAt(0).toUpperCase() + repl.slice(1);
    }
    return repl;
}

export function replaceCountyTerms(text, isMoldovaEnv) {
    if (!isMoldovaEnv || !text) return text;

    // Acceptă și fără diacritice: județ / judet (t/ț), cu/ fără plural, și case-insensitive
    // Ordinea contează: întâi formele mai lungi
    const rules = [
        { re: /\bjude[tț]ele\b/gi, to: "raioanele" },
        { re: /\bjude[tț]e\b/gi, to: "raioane" },
        { re: /\bjude[tț]ul\b/gi, to: "raionul" },
        { re: /\bjude[tț]\b/gi, to: "raion" },
    ];

    let out = text;
    for (const { re, to } of rules) {
        out = out.replace(re, (m) => preserveFirstCase(m, to));
    }
    return out;
}
